export const REQUEST_VISITOR_AUTHENTICATION = 'REQUEST_VISITOR_AUTHENTICATION';
export const ASSOCIATE_USER_ID_TO_VISITOR_ID = 'ASSOCIATE_USER_ID_TO_VISITOR_ID';
export const VISITOR_AUTH_SUCCESS = 'VISITOR_AUTH_SUCCESS';
export const VISITOR_AUTH_FAILURE = 'VISITOR_AUTH_FAILURE';

export const requestVisitorAuthentication = ({ visitorToken }) => ({
  type: REQUEST_VISITOR_AUTHENTICATION,
  payload: {
    visitorToken
  }
});

export const associateUserIdToVisitorId = ({ userId, visitorId, sessionId, visitorToken }) => ({
  type: ASSOCIATE_USER_ID_TO_VISITOR_ID,
  payload: {
    userId,
    visitorId,
    sessionId,
    visitorToken
  }
});

export const visitorAuthSuccess = ({ userId, sessionId, visitorToken }) => ({
  type: VISITOR_AUTH_SUCCESS,
  payload: {
    userId,
    sessionId,
    visitorToken
  }
});

export const visitorAuthFailure = ({ error }) => ({
  type: VISITOR_AUTH_FAILURE,
  payload: {
    error
  }
});
